import api from './api';

const styleService = {
    getAllStyles: async () => {
        const response = await api.get('/styles');
        return response.data;
    },

    getArtistStyles: async (profileId) => {
        const response = await api.get(`/styles/artist/${profileId}`);
        return response.data;
    }
};

export default styleService;
